import { SwalUtil } from 'src/app/services/utils/swal.util';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_GLOBAL } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { DatePipe } from '@angular/common';
import { GerarPdfOsService } from '../utils/gerar-pdf-os.service';

import * as jsPDF from 'jspdf';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  logo: any = [];
  usuario: any;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private pdfService: GerarPdfOsService,
    private swalUtil: SwalUtil,
  ) { }

  getRelatorios(id: any, params: any): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/reports/get-all?ordemservico_id=${params.ordemservico_id ? params.ordemservico_id : ''}&mes=${params.mes ? params.mes : ''}&ano=${params.ano ? params.ano : ''}&contract_id=${params.contract_id ? params.contract_id : ''}`, { headers: this.authService.userToken() });
  }

  getAllRelatorios(): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/reports/get-all`, { headers: this.authService.userToken() });
  }

  save(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/web/reports/store`, data, { headers: this.authService.userToken() });
  }

  destroy(id: any): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/web/reports/destroy/${id}`, { headers: this.authService.userToken() });
  }

  pacientesatribuidosaoprofissional(id): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/pacientesatribuidos/${id}`, { headers: this.authService.userToken() });
  }

  relatoriosprestador(id): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/reports/reportsByPrestador/${id}`, { headers: this.authService.userToken() });
  }

  findReport(id): Observable<any> {
    return this.http.get<any[]>(`${URL_GLOBAL}/web/reports/getReportById/${id}`, { headers: this.authService.userToken() });
  }

  update(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/web/reports/update/${id}`, data, { headers: this.authService.userToken() });
  }

  pegaUsuario() {
    this.usuario = JSON.parse(this.authService.getUserLoggedIn());
    if (this.usuario?.user.pessoa.profissional) this.logo = this.usuario.user.pessoa.profissional.empresa
    if (this.usuario?.user.pessoa.cliente) this.logo = this.usuario.user.pessoa.cliente.empresa
    if (this.usuario?.user.pessoa.responsavel) this.logo = this.usuario.user.pessoa.responsavel.empresa
  }

  pdf(report, service_day, first_day, last_day, {dias}) {

    console.log(dias)
    this.pegaUsuario();
    var doc = new jsPDF();
    let pdf_pages = doc.internal.pages;
    let cor;
    let service_forecast: Array<any> = [];
    let servicesDay: Array<any> = [];

    let service = this.getServices(report);

    const isNotProfessionalForHH = this.usuario?.user?.pessoa?.profissional?.empresa_id != 42;

    const isNotProfessionalForMaisSaude = this.usuario?.user?.pessoa?.profissional?.empresa_id != 28;

    if (report.prestador.formacoes == "Enfermagem") {
      doc.setFillColor(253, 223, 223)
      doc.setTextColor(196, 107, 107)
      cor = [196, 107, 107]
    } else {
      doc.setFillColor(217, 237, 247)
      doc.setTextColor(124, 124, 213)
      cor = [124, 124, 213]
    }

    (doc as any).autoTable({
      head: [[{ colSpan: 2, content: 'Dados do Paciente' }]],
      body: [
        [
          [`Nome: ${report?.paciente?.pessoa?.nome}`],
          [`Data de Nascimento: ${new DatePipe('pt-BR').transform(report?.paciente?.pessoa?.nascimento, 'dd/MM/yyyy')}`],
        ],
        [
          [`Convênio: ${report?.contract_id != null ? report?.contract?.cliente?.pessoa?.nome : report?.ordemservico?.orcamento?.cliente?.pessoa?.nome}`],
          [`Tel: ${report.paciente?.pessoa?.telefones.length > 0 ? report.paciente?.pessoa?.telefones[0]?.telefone : ''}`]
        ],
        [
          [
            `Cidade: ${report?.paciente?.pessoa?.enderecos.length > 0 ? (report?.paciente?.pessoa?.enderecos[0].cidade ? report?.paciente?.pessoa?.enderecos[0].cidade.nome : '') : ''} - ${report?.paciente?.pessoa?.enderecos.length > 0 ? (report?.paciente?.pessoa?.enderecos[0].cidade ? report?.paciente?.pessoa?.enderecos[0].cidade.uf : '') : ''}`
          ],
          [
            `CEP: ${report?.paciente?.pessoa?.enderecos.length > 0 ? (report?.paciente?.pessoa?.enderecos[0].cep ? report?.paciente?.pessoa?.enderecos[0].cep : '') : ''}`
          ]
        ],
        [
          [
            `Logradouro: ${report?.paciente?.pessoa?.enderecos.length > 0 ? (report?.paciente?.pessoa?.enderecos[0].rua ? report?.paciente?.pessoa?.enderecos[0].rua : '') : ''} - ${report?.paciente?.pessoa?.enderecos.length > 0 ? (report?.paciente?.pessoa?.enderecos[0].numero ? report?.paciente?.pessoa?.enderecos[0].numero : '') : ''}`
          ],
          [
            `Bairro: ${report?.paciente?.pessoa?.enderecos.length > 0 ? (report?.paciente?.pessoa?.enderecos[0].bairro ? report?.paciente?.pessoa?.enderecos[0].bairro : '') : ''}`
          ]
        ],
      ],
      startY: 35,
      theme: 'grid',
      tableWidth: 'auto',
    });

    (doc as any).autoTable({
      head: [[{ colSpan:2, content: `Dados do relatório - ${report.servico.descricao}`}]],
      body: [
        [`Profissional: ${report?.prestador?.pessoa?.nome}`, `Conselho: ${report.prestador?.pessoa?.conselhos[0]?.instituicao} - ${report.prestador?.pessoa?.conselhos[0]?.numero}`],
        [`Período: ${first_day ? new DatePipe('pt-BR').transform(first_day.dataentrada, 'dd/MM/yyyy') : '-'} á ${last_day ? new DatePipe('pt-BR').transform(last_day.dataentrada, 'dd/MM/yyyy') : '-'}`, `Data da avaliação: ${new DatePipe('pt-BR').transform(report?.created_at, 'dd/MM/yyyy HH:mm')}`],
        ['Assinatura: '],
      ],
      startY: doc.lastAutoTable.finalY + 5,
      theme: 'grid',
      tableWidth: 'auto',
      didDrawCell: (data) => {
        if(report.assinatura) {
          if (data.section === 'body' && data.row.index === 2 && data.column.index === 1) {
            var base64ImgProf = report.assinatura
            doc.addImage(base64ImgProf, 'PNG', data.cell.x + 1, data.cell.y + 1, 18, 9)
          }
        }
      },
    });

    if (isNotProfessionalForMaisSaude && isNotProfessionalForHH) {
      (doc as any).autoTable({
        head: [['PAD de Atendimento']],
        body: service,
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        rowPageBreak: 'avoid',
        margin: { top: 35 }
      });
    }

    if (service_day && isNotProfessionalForHH) {
      let days_ = dias.reduce((x, y, i) => x + new DatePipe('pt-BR').transform(y, 'dd') + (i != (dias.length -1) ? ', ' : '') , '')
      // for (let i = 0; i < service_day.length; i++) {
        servicesDay.push(
          [
            `${days_}`,
            `${service_day[0] ? service_day[0].prestador.pessoa.nome : '' }`
          ]
        );
      // }

      if (isNotProfessionalForMaisSaude && isNotProfessionalForHH) {
        (doc as any).autoTable({
          head: [[{ colSpan: 2, content: 'Atendimento Realizados' }], ['Data', 'Profissional']],
          body: servicesDay,
          startY: doc.lastAutoTable.finalY + 5,
          theme: 'grid',
          tableWidth: 'auto',
          rowPageBreak: 'avoid',
          margin: { top: 35 }
        });
      }
    }

    if (isNotProfessionalForHH && report.ml_service_forecast) {
      for (let i = 0; i < report.ml_service_forecast.length; i++) {
        service_forecast.push(
          [
            `${new DatePipe('pt-BR').transform(report.ml_service_forecast[i].date, 'dd/MM/yyyy')}`,
            `${report.ml_service_forecast[i].observation}`
          ]
        );
      }

      (doc as any).autoTable({
        head: [[{ colSpan: 2, content: 'Previsão de Atendimento' }], ['Data', 'Obs/Serviço']],
        body: service_forecast,
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        rowPageBreak: 'avoid',
        margin: { top: 35 }
      });
    }

    (doc as any).autoTable({
      head: [['Diagnóstico Inclusivo']],
      body: [
        [report.inclusion_diagnosis]
      ],
      startY: doc.lastAutoTable.finalY + 5,
      theme: 'grid',
      tableWidth: 'auto',
      pageBreak: 'avoid',
      margin: { top: 35 }
    });

    (doc as any).autoTable({
      head: [['Histórico Clínico']],
      body: [
        [report.historico_clinico]
      ],
      startY: doc.lastAutoTable.finalY + 5,
      theme: 'grid',
      tableWidth: 'auto',
      pageBreak: 'avoid',
      margin: { top: 35 }
    });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [['Resumo da Internação']],
        body: [
          [report.hospitalization_summary]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    (doc as any).autoTable({
      head: [['Evolução Mensal']],
      body: [
        [report.month_evolution]
      ],
      startY: doc.lastAutoTable.finalY + 5,
      theme: 'grid',
      tableWidth: 'auto',
      pageBreak: 'avoid',
      margin: { top: 35 }
    });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [[{ colSpan: 5, content: 'Sinais Vitais' }], ['Pressão Arterial', 'Pulso', 'Temperatura', 'Frequência', 'Saturação']],
        body:
        [
          [
            `${(report.pa != '' && report.pa != null) ? report.pa : ''}`,
            `${(report.p != '' && report.p != null) ? report.p : ''}`,
            `${(report.t != '' && report.t != null) ? report.t : ''}`,
            `${(report.fr != '' && report.fr != null) ? report.fr : ''}`,
            `${(report.sat != '' && report.sat != null) ? report.sat : ''}`
          ]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [['Equipamentos']],
        body: [
          [report.equipments]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [['Dispositivos']],
        body: [
          [report.dispositivo]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [['Quadro Motor']],
        body: [
          [report.quadro_motor]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [['Quadro Respiratório']],
        body: [
          [report.quadro_respiratorio]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [['Sistemas (gastrintestinais, geniturinário, pele e tegumento)']],
        body: [
          [report.systems]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [['Orientações e Conduta']],
        body: [
          [report.guidelines_conduct]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [['Metas Terapêuticas (prognóstico)']],
        body: [
          [report.metas_terapeuticas]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    if (isNotProfessionalForHH)
      (doc as any).autoTable({
        head: [['Justificativa']],
        body: [
          [report.justifications]
        ],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });

    if (isNotProfessionalForHH && (report.historico != '' && report.historico != null)) {
      (doc as any).autoTable({
        head: [['Histórico']],
        body: [[report.historico]],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid'
      });
    }

    if (isNotProfessionalForHH && (report.objetivo != '' && report.objetivo != null)) {
      (doc as any).autoTable({
        head: [['Objetivo']],
        body: [[report.objetivo]],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });
    }

    if (isNotProfessionalForHH && (report.planos_terapeutico != '' && report.planos_terapeutico != null)) {
      (doc as any).autoTable({
        head: [['Plano Terapéuticos']],
        body: [[report.planos_terapeutico]],
        startY: doc.lastAutoTable.finalY + 5,
        theme: 'grid',
        tableWidth: 'auto',
        pageBreak: 'avoid',
        margin: { top: 35 }
      });
    }

    for (let i = 1; i < pdf_pages.length; i++) {
      doc.setPage(i)
      this.pdfService.headerFooterPage(doc, i, `Relatório - ${report.servico.descricao} - ${report.mes}/${report.ano}`, this.usuario, this.logo)
    }
    doc.save(`Relatório ${report.servico.descricao} ${report.mes}/${report.ano}.pdf`);
  }

  getServices(array) {
    let arrayServices = [];
    let services = [];
    let servicesPackage = [];
    let servicesPackageCustom = [];
    let servicesUnity = [];
    let servicesAdditions = [];
    let servicesExtension = [];
    if (array.contract_id != null) {
      // pegar os servicos dos pacotes
      if (array?.contract?.budget?.package_budget) {
        for (let j = 0; j < array?.contract?.budget?.package_budget.length; j++) {
          for (let i = 0; i < array?.contract?.budget.package_budget[j]?.package?.ml_packages_services.length; i++) {
            servicesPackage.push(array?.contract?.budget?.package_budget[j]?.package.ml_packages_services[i]);
          }
        }
      }

      // pegar os servicos dos pacotes personalizado
      if (array?.contract?.budget?.package_custom) {
        for (let j = 0; j < array?.contract?.budget?.package_custom.length; j++) {
          for (let i = 0; i < array?.contract?.budget?.package_custom[j]?.custom_service.length; i++) {
            servicesPackageCustom.push(array?.contract?.budget?.package_custom[j]?.custom_service[i]);
          }
        }
      }

      // pegar os servicos avulsos
      if (array?.contract?.budget?.budget_service) {
        for (let j = 0; j < array?.contract?.budget?.budget_service.length; j++) {
          servicesUnity.push(array?.contract?.budget?.budget_service[j]);
        }
      }

      // pegar os servicos do aditivo
      if (array?.contract?.additions) {
        for (let j = 0; j < array?.contract?.additions.length; j++) {
          for (let i = 0; i < array?.contract?.additions[j]?.ml_servicos.length; i++) {
            servicesAdditions.push(array?.contract?.additions[j]?.ml_servicos[i]);
          }
        }
      }

      // pegar os serviços de prorrogação
      if (array?.contract?.extension) {
        for (let j = 0; j < array?.contract?.extension.length; j++) {
          for (let i = 0; i < array?.contract?.extension[j]?.extension_services.length; i++) {
            servicesExtension.push(array?.contract?.extension[j]?.extension_services[i]);
          }
        }
      }


      services = servicesPackage.concat(servicesUnity, servicesPackageCustom, servicesAdditions, servicesExtension)
      //verifica se existe dados da tabela de serviços finalizados e realiza a filtragem para ver se tem serviços finalizados e se houver, ele é retirado
      if (array?.finish_service) {
        for (let fs = 0; fs < array?.finish_service.length; fs++) {
          services = services.filter(x => x.id != array?.finish_service[fs]?.service_id)
        }
      }

      for (let s = 0; s < services.length; s++) {
        const element = services[s];
        arrayServices.push(
          [element.servico.descricao + ': ' + (element.quantity ? element.quantity : '') + ' ' + (element.billing_basis ? element.billing_basis : '') + ' ' + (element.frequency ? element.frequency : '')]
        );
      }
      return arrayServices;
    }
    else {
      for (let index = 0; index < array.ordemservico.orcamento.servicos.length; index++) {
        const element = array.ordemservico.orcamento.servicos[index];
        arrayServices.push(
          [element.descricao + ': ' + (element.quantidade ? element.quantidade : '') + ' ' + (element.basecobranca ? element.basecobranca : '') + ' ' + (element.frequencia ? element.frequencia : '')]
        );
      }
      return arrayServices;
    }
  }
}
